export class InlineArrayHeaderContainer {
  arrayItem: any;
  hasValues: boolean;
  headlineFields: Array<any>;
  labels: Array<any>;
  timeOutId: any;
  values: object;
}
